import React, { useCallback, useMemo } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Components
import Tabs from '../../../../components/display/Tabs';

// Redux
import { tabsType } from '../../../../state/reducers/ui/tabs';
import { roidOTSelectedReset } from '../../../../state/actions/ui/roidOTSelectedGeneralView';

//Styles
import { ContainerStyled } from './styles';

// Derive tab index from URL path (supports reload & direct navigation)
const TAB_PATHS = [
  '/work-orders',
  '/work-orders/accidents',
  '/work-orders/communications',
  '/work-orders/actions',
  '/work-orders/multimedia',
];

const getIndexFromPath = (pathname: string): number => {
  const normalized = pathname.replace(/\/$/, '');
  const idx = TAB_PATHS.indexOf(normalized);
  return idx >= 0 ? idx : 0;
};

export default function GeneralViewPage(): JSX.Element {
  const { t } = useTranslation('pages');
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // URL is the source of truth for the active tab on mount/reload
  const urlIndex = getIndexFromPath(location.pathname);

  const dataTab = useMemo(() => [
    {
      label: t('workOrders.preview'),
    },
    {
      label: t('workOrders.accidents'),
    },
    {
      label: t('workOrders.communications'),
    },
    {
      label: t('workOrders.actions'),
    },
    {
      label: t('workOrders.multimedia'),
    },
  ], [t]);

  // Navigate when the selected tab changes (via click).
  // On mount/reload this is a no-op because the URL already matches.
  const handleTabChange = useCallback((newIndex: number) => {
    const currentPath = location.pathname.replace(/\/$/, '');
    const targetPath = TAB_PATHS[newIndex] || TAB_PATHS[0];

    if (currentPath !== targetPath) {
      if (newIndex > 0) {
        dispatch(roidOTSelectedReset());
      }
      navigate(targetPath);
    }
  }, [location.pathname, navigate, dispatch]);

  return (
    <ContainerStyled>
      <Tabs
        data={dataTab}
        typeTab={tabsType.WORK_ORDERS_GENERAL}
        defaultIndex={urlIndex}
        setSelectedIndexTab={handleTabChange}
      />
      <Outlet />
    </ContainerStyled>
  );
}
